var React = require('react');

function SlideArrowRightOn (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#10C64E"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M43.771 23.654c-.034-.25-.139-.662-.3-.857L35.243 12.51c-.49-.612-1.368-.663-1.929-.214-.56.449-.663 1.367-.214 1.928l6.45 8.058H5.371c-.757 0-1.371.614-1.371 1.371s.614 1.371 1.371 1.371H39.55l-6.45 8.058c-.449.56-.322 1.45.214 1.928.561.5 1.48.347 1.929-.214L43.47 24.51c.233-.284.282-.495.3-.857z","transform":"translate(-1262 -2317) translate(1202 2317) matrix(1 0 0 -1 60 48)"}))))));
}

SlideArrowRightOn.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = SlideArrowRightOn;

SlideArrowRightOn.default = SlideArrowRightOn;
